module.exports = __webpack_public_path__ + "static/media/villa_tn.6afc6d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/villa_tn.jpg
// module id = 694
// module chunks = 0